import bankQrCodeDollar from "../assets/ac_USD.png";
import bankQrCodeRiel from "../assets/ac_KHR.png";
import acledaLogoForInvoice from "../assets/acledaLogoForInvoice.png";
import { useEffect, useState } from "react";
import React, { useRef } from 'react';
import { generateInvoicePDF } from '../utils/GeneratePdf';
export default function Invoice1 ({building, monthYear, room_number })  {
    const [dataAll, setDataAll] = useState();
    const [isDownloading, setIsDownloading] = useState(false);
    const invoiceRef = useRef(null);
    // const downloadPDF = usePDFDownload(invoiceRef);
    const date = new Date();
    // ==================>> Fetch API
    const getPaymentInfo = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/payment/invoice?monthYear=${monthYear}&building=${building}&room_number=${room_number}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message);
            }

            const data = await response.json();
            setDataAll(data);
        } catch (err) {
            console.error(err.message);
        }
    };

    useEffect(() => {
        getPaymentInfo();
    }, [building, monthYear]);

    const handleDownload = async () => {
        setIsDownloading(true);
        if (invoiceRef.current) {
            await generateInvoicePDF(invoiceRef.current);
        }
        setIsDownloading(false);
    };

    // Add formatter function
    const formatNumber = (num) => {
        if (!num && num !== 0) return '--';
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    return (
        <div>
            <div className="w-full flex justify-center">
            <button 
                    onClick={handleDownload}
                    disabled={isDownloading}
                    className={`bg-blue-500 text-white px-4 py-3 rounded ${isDownloading ? 'opacity-75 cursor-not-allowed' : ''}`}
                >
                    {isDownloading ? 'Download PDF ...' : 'Download PDF'}
                </button>
            </div>
            <div className="w-full" ref={invoiceRef}>
                {dataAll ? (dataAll.map((data, index) =>(
                    <div className="w-[100dvh] p-8" key={index}>
                        <div className="flex w-[94dvh] h-[6dvh] text-center border border-black font-semibold items-center text-xl">
                            <div className="w-[31.9dvh] flex border-r pb-5 items-center  border-black h-full justify-center">{data ? data.room_number : '--'}</div>
                            <div className="w-[56.4dvh] flex h-full pb-5 items-center justify-center">វិក័យបត្របង់ប្រាក់បន្ទប់ជួល</div>
                        </div>
                        <div className="w-[94dvh] mx-0">
                            <table className="border-collapse text-center w-full bg-white !text-xl">
                                <thead>
                                    <tr className="">
                                        <th className="w-[18.8dvh] border-x border-b border-black py-2 text-base"></th>
                                        <th className="w-[35.9dvh]">
                                            <div className="w-full flex">
                                                <div className="border-r pb-4 w-[18dvh] border-b border-black  text-xl">
                                                    ខែ {data ? data.current_month : '--'}
                                                </div>
                                                <div className="border-b pb-4 w-[18dvh] border-black  text-xl">
                                                    ខែ {data ? data.previous_month : '--'}
                                                </div>
                                            </div>
                                        </th>
                                        <th className="w-[30dvh] border-x border-b border-black  text-xl pb-4">
                                            ចំនួន
                                        </th>
                                        <th className="w-[30dvh] border-r border-b border-black  text-xl pb-4">
                                            តម្លៃសរុប
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="w-[94dvh]">
                                        <td className="w-[18.8dvh] border-b border-x border-1 border-black pb-3.5 font-semibold">កុងទ័រ ទឹក</td>
                                        <td className="w-[35.9dvh] border-r pb-3.5 border-black">
                                            {data ?
                                                (Number(data.current_water_usage) % 1 === 0
                                                        ? Number(data.current_water_usage).toFixed(0) 
                                                        : Number(data.current_water_usage).toFixed(2) 
                                                    ): ('--')} - {data ?
                                                (Number(data.previous_water_usage) % 1 === 0
                                                    ? Number(data.previous_water_usage).toFixed(0) 
                                                    : Number(data.previous_water_usage).toFixed(2) 
                                                ): ('--')}
                                        </td>
                                        <td className="w-[18.8dvh] border-r pb-3.5 border-black">{data ? formatNumber(data.water_usage_price / 2000) : '--'} x 2,000</td>
                                        <td className="w-[18.8dvh] border-r pb-3.5  border-black pl-2 text-left">= {data ? formatNumber(Number(data.water_usage_price)) : '--'} ៛</td>
                                    </tr>
                                    <tr className="margin-bottom w-[94dvh]">
                                        <td className="w-[18.8dvh] border-x border-b pb-3.5 border-black font-semibold">តម្លៃភ្លើង</td>
                                        <td className="w-[35.9dvh] border-r border-y pb-3.5 border-black mb-5">គិតតាមវិក័យបត្រអគ្គិសនីកម្ពុជា</td>
                                        <td className="w-[30dvh] border-r border-y pb-3.5 border-black">{data ? (Number(data.electricity_usage) === 0 ? 0 : formatNumber(Number(data.electricity_usage) - 1000) + " + 1,000") : '--'}</td>
                                        <td className="w-[30dvh] border-r border-y pb-3.5 border-black text-left pl-2">= {data ? formatNumber(Number(data.electricity_usage)) : '--'} ៛</td>
                                    </tr>
                                </tbody>
                            </table>
                            {/* Add table content similar to your provided layout */}
                        </div>
                        <div className="flex md:flex-row w-[94dvh] !text-xl">
                            <div className="w-[56.4dvh] pl-2">
                                <div className="bg-yellow-100 border px-4 pb-4 rounded-md shadow-md md:w-[90%] mt-2">
                                    <h3 className="font-medium text-base">ទូរស័ព្ទអ្នកជួល: {data && data.tenant_phone_number ? 
                                                            data.tenant_phone_number.replace(/(\d{3})(\d{3})(\d{3,4})/, '$1 $2 $3') 
                                                            : '--'}</h3>
                                </div>
                                <div className="flex w-full mx-2 my-2 items-center font-semibold">
                                    <img src={acledaLogoForInvoice} alt="acledaLogo" className="w-[40%]"/>
                                    <p className="pb-6">Ngeabkhai Eng</p>
                                </div>
                                <div className="flex w-full mx-6 space-x-4">
                                    <img src={bankQrCodeDollar} alt="bank-qr-code-dollor" className="w-24 h-24" />
                                    <img src={bankQrCodeRiel} alt="bank-qr-code-dollor" className="w-24 h-24" />
                                </div>

                                <div className="flex flex-col mr-auto">
                                    <p className="text-red-600 text-base">សូមអញ្ជើញមកបង់ប្រាក់ឳ្យបានមុនថ្ងៃទី 15 ផុត 1ថ្ងៃគិត 1$</p>
                                    <p className="text-base">បើមានបញ្ហាណាមួយ សូមទូរស័ព្ទមកលេខ: </p>
                                    <p className="text-base">010 88 10 11, 095 88 10 11, 088 98 81 011</p>
                                </div>
                            </div>
                            <div className="w-[50dvh]">
                                <div className="w-full">
                                    <table className="w-full border-collapse">
                                        <tbody>
                                            <tr className="w-[100dvh]">
                                                <td className="w-[50dvh] border-x border-b text-center border-black pb-3.5">ថ្លៃសំរាម</td>
                                                <td className="w-[38.5dvh] border-r border-b border-black pl-2 pb-3.5">= {data ? formatNumber(Number(data.garbage)) : '--'} ៛</td>
                                            </tr>
                                            <tr className="">
                                                <td className="border-x border-b text-center border-black pb-3.5">ផ្ញើរយានជំនិះ</td>
                                                <td className="border-r border-b border-black pb-3 pl-2">= {data ? formatNumber(Number(data.vehicle_charge)) : '--'} ៛</td>
                                            </tr>
                                            <tr className="">
                                                <td className="border-x border-b text-center border-black pb-4">ថ្លៃខ្វះ</td>
                                                <td className="border-r border-b border-black pb-3 pl-2">= {data ? formatNumber(Number(data.old_debt)) : '--'} $</td>
                                            </tr>
                                            <tr className="">
                                                <td className="border-x border-b text-center border-black pb-4">ថ្លៃបន្ទប់</td>
                                                <td className="border-x border-b border-black pb-3 pl-2 text-xl">= {data ? formatNumber(Number(data.price)) : '--'} $ {data ? (data.late_penalty && data.late_penalty != 0 ? <span className="text-red-600">+ {formatNumber(Number(data.late_penalty))}$</span> : <span></span>) : ''}</td>
                                            </tr>
                                            <tr className="text-white">
                                                <td className="bg-primary2 border-x border-b text-center border-black pb-4">តម្លៃសរុប (៛)</td>
                                                <td className="border-x border-b text-black border-black pb-3 pl-2 font-bold text-xl">= {data ? formatNumber(Number(data.total_debt) * 4000) : '--'}៛</td>
                                            </tr>
                                            <tr className=" text-white">
                                                <td className="bg-primary2 border-x border-b text-center border-black pb-4">តម្លៃសរុប ($)</td>
                                                <td className="border-x border-b text-black border-black pb-3.5 pl-2 font-bold text-xl">= {data ? formatNumber(Number(data.total_debt)) : '--'}$</td>
                                            </tr>

                                            {/* <tr className="bg-primary2 text-white">
                                                <td className="border-x border-b text-center border-black pb-5">ថ្លៃបន្ទប់</td>
                                                <td className="border-r border-b text-center border-black pb-5">តម្លៃសរុប</td>
                                            </tr> */}
                                            {/* <tr className="">
                                                <td className="border-x border-b border-black pb-5 pl-2 font-bold text-xl">= {data ? Number(data.price) : '--'} $ {data ? (data.late_penalty && data.late_penalty != 0 ? <span className="text-red-600">+ {Number(data.late_penalty)}$</span> : <span></span>) : ''}</td>
                                                <td className="border-r border-b border-black pb-5 pl-2 font-bold text-xl">= {data ? Number(data.total_amount) : '--'} ៛</td>
                                            </tr> */}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full -mt-5">
                            {/* <div className="flex flex-col mr-auto">
                                <p className="text-red-600 text-base">សូមអញ្ជើញមកបង់ប្រាក់ឳ្យបានមុនថ្ងៃទី 15 ផុត 1ថ្ងៃគិត 1$</p>
                                <p>បើមានបញ្ហាណាមួយ សូមទូរស័ព្ទមកលេខ: </p>
                                <p>010 88 10 11, 095 88 10 11, 060 40 31 42</p>
                            </div> */}
                            <div className="flex items-end mr-4 ml-auto">
                                <p>កាលបរិច្ឆេទ: {date.getDate()} / {date.getMonth() + 1} / {date.getFullYear()} </p>
                            </div>
                        </div>
                    </div>
                ))) : <div></div>}
            </div>

        </div>
    );
};
